import React from 'react'
import PropTypes from 'prop-types'
import styles from '../index.module.scss'

const Question = ({ question, collapsed, onClick }) => (
  <div
    role="none"
    onClick={() => onClick(question.key)}
    className="flex cursor-pointer flex-row-reverse items-center justify-between lg:flex-row lg:justify-start"
    data-testid="question"
  >
    <div className="size-3 select-none lg:mr-4" style={{ minWidth: '0.75rem' }}>
      <div className={`${styles.horizontal}`} />
      <div
        className={
          collapsed
            ? `${styles.verticalCollapsed}`
            : `${styles.verticalExpanded}`
        }
      />
    </div>
    <strong className="text-gray-245 lg:text-lg">{question.question}</strong>
  </div>
)

Question.propTypes = {
  onClick: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired,
  question: PropTypes.object.isRequired,
}

export default React.memo(Question)
